<div class="content-wrapper-addrole">
    <table class="mainTable-addrole" cellspacing="2" cellpadding="0">
        <tbody>
            <tr>
                <td class="td-addrole">
                    <div class="whatsnewBorder-addrole">
                        <table>
                            <tbody>
                                <tr>
                                    <span class="summaryTitle-addrole">
                                        {{'Search for users to assign SBDO roles'|translate}}
                                    </span>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td class="heading-addrole">
                                        {{'Username'|translate}}:&nbsp;
                                        <input [(ngModel)]="usernameaddrole" type="text" name="username"
                                            size="10" value="" id="username" class="addrole-input">&nbsp;
                                        {{'Last Name'|translate}}:&nbsp;<input [(ngModel)]="lastNameAddrole" type="text" name="lastName"
                                            size="10" value="" id="lastName" class="addrole-input">&nbsp;
                                        <select name="userType" [(ngModel)]="staffaddrole" class="select-addrole">
                                            <option *ngFor="let i of manageUserType" [value]="i.userTypeId">
                                                <span *ngIf="1 == i.userTypeId">{{'Ford Internal'|translate}}</span>
                                                <span *ngIf="2 == i.userTypeId">{{'Independent'|translate}} </span>
                                                <span *ngIf="3  == i.userTypeId">{{'Authorized'|translate}} </span>
                                            </option>
                                        </select>&nbsp;
                                        <input class="input-btn-addrole" type="button" value="{{'Submit'|translate}}" (click)="getUseraddroleDetails()">&nbsp;
                                        <input class="input-btn-addrole" type="button" type="reset" value="{{'Clear'|translate}}" (click)="closeaddroletabs()">
                                    </td>
                                </tr>
                                <tr *ngIf="!errormsgaddrole">
                                    <td>&nbsp;</td>
                                </tr>
                                <div *ngIf="errormsgaddrole" class="errors-addrole ng-star-inserted">
                                    <span class="fa fa-exclamation-triangle"></span>
                                    <span class="msg-addrole">{{'Please enter either a Username or a Lastname'|translate}}</span>
                                </div>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="apierrormsg" class="errorsapi-addrole ng-star-inserted">
        <span class="fa fa-exclamation-triangle"></span>
        <span class="msgapi-addrole">{{'No results were found for your search'|translate}}</span>
    </div>
    <div *ngIf="detailstable" class="whatsnewBorder-addrole secondborder">
        <table class="secondtable-addrole">
            <tbody>
                <tr>
                    <th>{{'User Name'|translate}}</th>
                    <th>{{'User Type'|translate}}</th>
                    <th>{{'First Name'|translate}}</th>
                    <th>{{'Last Name'|translate}}</th>
                    <th>{{'Email'|translate}}</th>
                    <th>{{'Market Country'|translate}}</th>
                    <th>{{'Language'|translate}}</th>
                    <th></th>
                </tr>
                <tr *ngFor="let i of getaddroleuserdetaildata;">
                    <td>{{i.username}}</td>
                    <td>
                        <span *ngIf="1 == i.userType">{{'Ford Internal Personnel'|translate}}</span>
                        <span *ngIf="2 == i.userType">{{'Independent Operator'|translate}}</span>
                        <span *ngIf="3 == i.userType">{{'Authorized Repairer'|translate}}</span>
                    </td>
                    <td>{{i.firstName}}</td>
                    <td>{{i.lastName}}</td>
                    <td>{{i.email}}</td>
                    <td>{{i.marketCountry}}</td>
                    <td>{{i.language}}</td>
                    <td *ngIf="1 == i.userType">
                        <a class="admintab-addrole"
                            (click)="getAddUserRoleDetails(i.username,i.userType,i.firstName,
                            i.lastName,i.email,i.marketCountry,i.language);selectAddRoleUser(setadminrole);">
                            {{'Administer User'|translate}}</a>
                    </td>
                    <td *ngIf="1 != i.userType"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="modal-dialog modal-sm">
        <ng-template #setadminrole let-modal>
            <div class="modal-header-addrole">
                <span class="header-popup-text-addrole">{{'Assign Role'|translate}}</span>
                <i class="fa fa-times mng-qualifier-close-btn close-addrole-popup"
                    (click)="modal.dismiss('Cross click')" title="close"></i>
            </div>
            <div class="popupborder-addrole">
                {{'User Name'|translate}}: <span class="usernamepopup">{{unameAddrole}}</span>
                {{'Email'|translate}}: <span class="usernamepopup">{{email}}</span>
                <table class="mainTable-addrole popuptable-addrole">
                    <tbody>
                        <tr>
                            <td class="popup_heading-addrole">{{'Available Roles'|translate}}</td>
                            <td>&nbsp;</td>
                            <td class="popup_heading-addrole">{{'Selected Roles'|translate}}</td>
                        </tr>
                        <tr>
                            <td class="popup-addrole-size">
                                <select class="popup-addrole-size-two" size="3" multiple="true" name="qualifier"
                                    [(ngModel)]="useravailAddrole">
                                    <option *ngFor="let availdet of getaddroleavail">
                                        {{availdet}}
                                    </option>
                                </select>
                            </td>
                            <td class="popup-addrole-size-one">
                                <input type="button" value=" ->" (click)="addRoleAdd()"><br>
                                <input type="button" value="<- " (click)="removeAddRole()"><br>
                            </td>
                            <td class="popup-addrole-size">
                                <select class="popup-addrole-size-two" size="3" multiple="true" name="roleIds"
                                    [(ngModel)]="userselectaddrole">
                                    <option *ngFor="let details of getaddroleselect">
                                        {{details}}</option>
                                </select>
                            </td>
                        </tr>
                        <tr *ngIf="rolesetsucess" class="sucessaddrolepopup">{{'Role has been set successfully'|translate}}</tr>
                        <tr *ngIf="rolesetfail" class="failureaddrolepopup">{{'Role has NOT been set'|translate}}!</tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer modal-footer-addrole">
                <input class="input-btn-addrole" type="button" value="{{'Set Role'|translate}}" (click)="setAddRoleUserRoleDetails()">
                &nbsp;&nbsp;<input class="input-btn-addrole" type="button" value="{{'Close'|translate}}" (click)="modal.close('Close click')">
            </div>
        </ng-template>
    </div>
</div>